// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lycanroc_midday: PokeData = {
  "id": 745,
  "name": "lycanroc-midday",
  "height": 8,
  "weight": 250,
  "base_experience": 170,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "leer",
    "bite",
    "roar",
    "rock-throw",
    "quick-attack",
    "double-team",
    "rock-slide",
    "scary-face",
    "crunch",
    "odor-sleuth",
    "rock-tomb",
    "howl",
    "sucker-punch",
    "rock-climb",
    "stone-edge",
    "stealth-rock",
    "quick-guard",
    "accelerock"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "rock-throw",
    "quick-attack",
    "rock-slide",
    "scary-face",
    "crunch",
    "rock-tomb",
    "stealth-rock",
    "power-siphon",
    "rock-smash",
    "stone-crush"
  ],
  "evolution_chain": {
    "id": 383,
    "item": null,
    "species": [
      {
        "name": "rockruff",
        "order": 744,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lycanroc",
        "order": 745,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 744,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "dusk",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 151,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
